import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";

const styles = {
  cardControlButtonStyles: {
    p: "4px 8px 4px 8px",
    borderRadius: "50%",
    width: "36px",
    height: "36px",
    float: 'right'
  },
  iconStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "300px"
  },
  tonalButtonsContainer: {
    m: {
      xs: "0 20px 0 0",
      sm: "0 32px 0 0",
      md: "0 140px 0 0"
    },
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }
};

export interface TonalIconProps {
  icon: string;
  alt: string;
  height?: string | number;
  width?: string | number;
  background?: string;
  hoverBackground?: string;
  handleOnClick?: () => void;
  tabIndex?: number;
  ariaLabel?: string;
  title?: string;
}

const TonalIcon = (props: TonalIconProps) => {
  const { icon, alt, height, width, background, hoverBackground, handleOnClick, tabIndex, title } = props;
  try {
    return (
      <IconButton
        aria-label={props?.ariaLabel || (props?.title ? `navigate to ${title} genre pack` : `${alt}`)}
        data-testid="tonal-icon"
        tabIndex={tabIndex || 0}
        sx={{
          ...styles.cardControlButtonStyles,
          background,
          "&:hover, &:active, &:focus": {
            background: hoverBackground
          }
        }}
        onClick={handleOnClick}
      >
        <CardMedia
          alt={alt || "rightArrow"}
          aria-hidden={true}
          component={"img"}
          height={height}
          loading="lazy"
          src={icon}
          sx={styles.iconStyles}
          width={width}
        />
      </IconButton>
    );
  } catch (error) {
    return <ErrorDisplay component="Tonal Icon" error={error} />;
  }
};

export default React.memo(TonalIcon);
